import React from 'react';
import { useTranslation } from 'react-i18next';

interface IPInfoProps {
  ip: string;
  asn?: string;
  ciudad?: string;
  latitud?: number | null;
  longitud?: number | null;
  isp?: string;
  ultima_actualizacion?: string;
  pais?: string;
  sistema_operativo?: string;
  puertos?: number[];
}

const IPInfo: React.FC<{ ipData: IPInfoProps }> = ({ ipData }) => {
  const { t } = useTranslation();

  return (
    <div
      className="bg-white p-6 rounded-lg shadow-lg mb-6"
      style={{ boxShadow: '0px 4px 10px rgba(169, 169, 169, 0.6)' }}
    >
      <h3 className="text-4xl font-bold mb-4">{t('ipInfo.title')}</h3>
      <table className="table-auto w-full border-collapse">
        <tbody>
          <tr className="border-b bg-gray-50 even:bg-gray-100">
            <td className="bg-gray-800 p-3 font-semibold text-center text-white">
              {t('ipInfo.table.ip')}
            </td>
            <td className="p-3">{ipData.ip}</td>
          </tr>
          <tr className="border-b bg-gray-50 even:bg-gray-100">
            <td className="bg-gray-800 p-3 font-semibold text-center text-white">
              {t('ipInfo.table.asn')}
            </td>
            <td className="p-3">{ipData.asn || t('ipInfo.unknown')}</td>
          </tr>
          <tr className="border-b bg-gray-50 even:bg-gray-100">
            <td className="bg-gray-800 p-3 font-semibold text-center text-white">
              {t('ipInfo.table.isp')}
            </td>
            <td className="p-3">{ipData.isp || t('ipInfo.unknown')}</td>
          </tr>
          <tr className="border-b bg-gray-50 even:bg-gray-100">
            <td className="bg-gray-800 p-3 font-semibold text-center text-white">
              {t('ipInfo.table.operating_system')}
            </td>
            <td className="p-3">{ipData.sistema_operativo || t('ipInfo.unknown')}</td>
          </tr>
          <tr className="border-b bg-gray-50 even:bg-gray-100">
            <td className="bg-gray-800 p-3 font-semibold text-center text-white">
              {t('ipInfo.table.location')}
            </td>
            <td className="p-3">
              {ipData.ciudad || t('ipInfo.unknown_city')}, {ipData.pais || t('ipInfo.unknown')}
              {ipData.latitud && ipData.longitud && (
                <>
                  {' '}
                  (Latitud: {ipData.latitud}, Longitud: {ipData.longitud})
                </>
              )}
            </td>
          </tr>
          <tr className="border-b bg-gray-50 even:bg-gray-100">
            <td className="bg-gray-800 p-3 font-semibold text-center text-white">
              {t('ipInfo.table.open_ports')}
            </td>
            <td className="p-3">
              {ipData.puertos?.join(', ') || t('ipInfo.none')}
            </td>
          </tr>
          <tr className="border-b bg-gray-50 even:bg-gray-100">
            <td className="bg-gray-800 p-3 font-semibold text-center text-white">
              {t('ipInfo.table.last_update')}
            </td>
            <td className="p-3">
              {ipData.ultima_actualizacion
                ? new Date(ipData.ultima_actualizacion).toLocaleString()
                : t('ipInfo.unknown')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default IPInfo;
